<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ vendorId ? "Edit Vendor" : "New Vendor" }}
  </h2>
  <form [formGroup]="newVendorForm" (ngSubmit)="onSubmit()">
    <!-- Format Selection -->
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Vendor Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Vendor Name"
            formControlName="vendorName"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('vendorName')!.touched &&
                newVendorForm.get('vendorName')!.hasError('required')
              "
              >Vendor name is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="newVendorForm.get('vendorName')!.hasError('maxlength')"
              >Vendor name must be at most 50 characters long.</mat-error
            >
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Contact Person <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Contact Person"
            formControlName="contactPerson"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('contactPerson')!.touched &&
                newVendorForm.get('contactPerson')!.hasError('required')
              "
              >Contact Person is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('contactPerson')!.touched &&
                newVendorForm.get('contactPerson')!.hasError('maxlength')
              "
              >Contact Person must be at most 50 characters long.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Email <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter email address"
            formControlName="email"
          />
        </mat-form-field>

        <div class="custom-error" *ngIf="newVendorForm.get('email')!.touched">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('email')!.touched &&
                newVendorForm.get('email')!.hasError('maxlength')
              "
              >Email must be at most 50 characters long.</mat-error
            >
          </span>
          <span>
            <mat-error *ngIf="newVendorForm.get('email')!.hasError('required')"
              >Email ID is required.
              <!-- Required Error - shows only if empty -->
            </mat-error>
          </span>
          <span>
            <!-- Invalid Email Format Error - shows only if not empty but invalid -->
            <mat-error
              *ngIf="
                newVendorForm.get('email')!.hasError('invalidEmail') &&
                !newVendorForm.get('email')!.hasError('required')
              "
              >Please enter a valid email address.</mat-error
            >
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Phone <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter phone number"
            formControlName="phone"
          />
        </mat-form-field>
        <div class="custom-error" *ngIf="newVendorForm.get('phone')!.touched">
          <span>
            <mat-error *ngIf="newVendorForm.get('phone')!.hasError('required')"
              >Phone number is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('phone')!.hasError('minlength') &&
                !newVendorForm.get('phone')!.hasError('required')
              "
            >
              Phone number must be at least 8 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('phone')!.hasError('maxlength') &&
                !newVendorForm.get('phone')!.hasError('required')
              "
            >
              Phone number cannot exceed 15 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('phone')!.hasError('pattern') &&
                !newVendorForm.get('phone')!.hasError('required')
              "
              >Invalid phone number. Only digits are allowed.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">TRN Number <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter TRN Number"
            formControlName="trn"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('trn')!.touched &&
                newVendorForm.get('trn')!.hasError('required')
              "
              >TRN number is required.</mat-error
            >
          </span>
          <!-- <span>
            <mat-error
              *ngIf="
                newVendorForm.get('trn')!.touched &&
                newVendorForm.get('trn')!.hasError('invalidTRN')
              "
            >
              Enter Valid TRN
            </mat-error>
          </span> -->
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Currency <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose Currency</mat-label>
          <mat-select formControlName="currency">
            <mat-option
              *ngFor="let type of currencyData"
              [value]="type.currencyCode"
            >
              {{ type.currencyCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newVendorForm.get('currency')!.touched &&
              newVendorForm.get('currency')!.hasError('required')
            "
          >
            Currency is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Address<span class="red">*</span></label>
        <mat-form-field>
          <textarea
            matInput
            placeholder="Street 1"
            formControlName="address"
          ></textarea>
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('address')!.touched &&
                newVendorForm.get('address')!.hasError('required')
              "
              >Address is required.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Opening Balance <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Opening Balance"
            formControlName="openingBalance"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('openingBalance')!.touched &&
                newVendorForm.get('openingBalance')!.hasError('required')
              "
              >Opening Balance is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newVendorForm.get('openingBalance')!.hasError('pattern') &&
                !newVendorForm.get('openingBalance')!.hasError('required')
              "
              >Invalid Opening Balance. Only digits are allowed.</mat-error
            >
          </span>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">Save</button>
    </div>
  </form>
</section>
